// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__FZJFf","loading":"Profile_loading__JeRNH","error":"Profile_error__doyhM","iconContainer":"Profile_iconContainer__BRizJ"};